import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/ar.ts
var add = "إضافة";
var remove = "إزالة";
var removeAll = "إزالة الكل";
var incomplete = "عذرا، لم يتم تعبئة جميع الحقول بشكل صحيح.";
var submit = "إرسال";
var noFiles = "لا يوجد ملف مختار";
var moveUp = "تحرك لأعلى";
var moveDown = "انتقل لأسفل";
var isLoading = "يتم الآن التحميل...";
var loadMore = "تحميل المزيد";
var next = "التالي";
var prev = "السابق";
var addAllValues = "أضف جميع القيم";
var addSelectedValues = "إضافة قيم محددة";
var removeAllValues = "قم بإزالة جميع القيم";
var removeSelectedValues = "إزالة القيم المحددة";
var chooseDate = "اختر التاريخ";
var changeDate = "تاريخ التغيير";
var close = "أغلق";
var open = "افتح";
var accepted = function({
  name
}) {
  return `الرجاء قبول ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `يجب أن يكون ${sentence(name)} بعد ${date(args[0])}.`;
  }
  return `يجب أن يكون ${sentence(name)} في المستقبل.`;
};
var alpha = function({
  name
}) {
  return `يمكن أن يحتوي ${sentence(name)} على أحرف أبجدية فقط.`;
};
var alphanumeric = function({
  name
}) {
  return `يمكن أن يحتوي ${sentence(name)} على أحرف وأرقام فقط.`;
};
var alpha_spaces = function({
  name
}) {
  return `يمكن أن تحتوي ${sentence(name)} على أحرف ومسافات فقط.`;
};
var contains_alpha = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على أحرف أبجدية.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على أحرف أو أرقام.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على أحرف أو مسافات.`;
};
var contains_symbol = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على رمز.`;
};
var contains_uppercase = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على أحرف كبيرة.`;
};
var contains_lowercase = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على أحرف صغيرة.`;
};
var contains_numeric = function({
  name
}) {
  return `يجب أن يحتوي ${sentence(name)} على أرقام.`;
};
var symbol = function({
  name
}) {
  return `يجب أن يكون ${sentence(name)} رمزًا.`;
};
var uppercase = function({
  name
}) {
  return `يمكن أن يحتوي ${sentence(name)} على أحرف كبيرة فقط.`;
};
var lowercase = function({
  name
}) {
  return `يمكن أن يحتوي ${sentence(name)} على أحرف صغيرة فقط.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `يجب أن يكون ${sentence(name)} قبل ${date(args[0])}.`;
  }
  return `يجب أن يكون ${sentence(name)} في الماضي.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `تمت تهيئة هذا الحقل بشكل غير صحيح ولا يمكن إرساله.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `يجب أن يكون ${sentence(name)} ما بين ${a} و ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} غير متطابق.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ليس تاريخًا صالحًا ، يرجى استخدام التنسيق ${args[0]}`;
  }
  return "تمت تهيئة هذا الحقل بشكل غير صحيح ولا يمكن إرساله";
};
var date_between = function({
  name,
  args
}) {
  return `يجب أن يكون ${sentence(name)} بين ${date(args[0])} و ${date(args[1])}`;
};
var email = "الرجاء أدخال بريد إليكتروني صالح.";
var ends_with = function({
  name,
  args
}) {
  return `لا ينتهي ${sentence(name)} بـ ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} ليست قيمة مسموح بها.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `يجب أن يكون ${sentence(name)} حرفًا واحدًا على الأقل.`;
  }
  if (min2 == 0 && max2) {
    return `يجب أن يكون ${sentence(name)} أقل من أو يساوي ${max2} حرفًا.`;
  }
  if (min2 === max2) {
    return `يجب أن يتكون ${sentence(name)} من الأحرف ${max2}.`;
  }
  if (min2 && max2 === Infinity) {
    return `يجب أن يكون ${sentence(name)} أكبر من أو يساوي ${min2} حرفًا.`;
  }
  return `يجب أن يكون ${sentence(name)} بين ${min2} و ${max2} حرفًا.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} ليست قيمة مسموح بها.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `لا يمكن أن يكون أكثر من ${args[0]} ${name}.`;
  }
  return `يجب أن يكون ${sentence(name)} أقل من أو يساوي ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "لا يسمح بتنسيقات الملفات.";
  }
  return `يجب أن يكون ${sentence(name)} من النوع: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `لا يمكن أن يكون أقل من ${args[0]} ${name}.`;
  }
  return `يجب أن يكون ${sentence(name)} على الأقل ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” ليس ${name} مسموحًا به.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} يجب ان يكون رقماً`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" أو ")} مطلوب.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} مطلوب.`;
};
var starts_with = function({
  name,
  args
}) {
  return `لا يبدأ ${sentence(name)} بـ ${list(args)}.`;
};
var url = function() {
  return `يرجى إدخال عنوان URL صالح.`;
};
var invalidDate = "التاريخ المحدد غير صالح.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var ar_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, ar_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=ar.mjs.map